<template>
	<el-skeleton style="width: 220px;margin-top:20px;" animated :rows="5">
		<template #template>
			<el-skeleton-item variant="image" style="width: 220px; height:130px" />
			<div style="padding:5px">
				<el-skeleton-item variant="p"/>
				<div style="
	            display: flex;
	            align-items: center;
	            justify-items: space-between;
	          ">
					<el-skeleton-item variant="text" style="margin-right: 16px" />
				</div>
				<el-skeleton-item variant="text" style="width: 30%;"  class="mt-1"/>
				<el-skeleton-item variant="p" class="mt-4"/>
			</div>
		</template>
	</el-skeleton>
</template>

<script>
</script>

<style>
</style>
